import { LocalStorageKey } from '../enums/localStorageKey.enum'

export const removeDataFromLocalStorage = (
  localStorageKey: LocalStorageKey
): void => {
  localStorage.removeItem(localStorageKey)
}
